import React, {ReactNode, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import type { CSSProperties, MouseEvent, PropsWithChildren } from "react";

import ArrowUp from "@/assets/icon/ArrowUp";
import ArrowDown from "@/assets/icon/ArrowDown";
import "@/styles/dropdown.scss";

interface Props {
	title: string | JSX.Element;
	options?: Array<{
		text: string;
		method?: () => void;
		link?: string;
		target?: "_self" | "_blank";
	}>;
	variant?: string;
	className?: string;
	arrow_fill?: string;
	id?: string;
    styles?: CSSProperties;
	children?: ReactNode
    disabled?: boolean;
    position?: {alignRight: boolean}
}

interface CustomToggleProps {
	onClick: (e: MouseEvent<HTMLElement>) => void;
	arrow_fill?: string;
	disabled: boolean;
	btnClassName?: string;
}

const CustomToggle = React.forwardRef(
    (
        {
            children,
            onClick,
            arrow_fill = "#545565",
            disabled
        }: PropsWithChildren<CustomToggleProps>,
        ref: React.ForwardedRef<HTMLButtonElement>,
    ) => {
        const [dropdown, setDropdown] = useState(false);

        function dropdownHandler(e: MouseEvent<HTMLElement>) {
            setDropdown((prev) => !prev);
            onClick(e);
        }

        const className = dropdown ? "active": "not_active";

        return (
            <button ref={ref} onClick={dropdownHandler} type="button" className={`btn p-0 dropdown_toggle ${className}`} disabled={disabled}>
                {children}
                <span className="ml-2">{dropdown ? <ArrowUp fill={arrow_fill} /> : <ArrowDown fill={arrow_fill} />}</span>
            </button>
        );
    },
);

/**
 * Dropdown: Displays hidden list when clicked
 * @param title
 * @param options
 * @param variant
 * @param className
 * @returns
 */

export default function SiteDropdown({
    title,
    options,
    variant,
    arrow_fill,
    className,
    children,
    position,
    styles = {},
    disabled = false,
    id="dropdown",
}: Props) {
    return (
        <Dropdown id={id} style={styles} className={className}>
            <Dropdown.Toggle variant={variant} as={CustomToggle} arrow_fill={arrow_fill} id={`dropdown-${title}`} disabled={disabled}>
                {title}
            </Dropdown.Toggle>

            {!disabled && <Dropdown.Menu {...position} aria-label={`${title} dropdown`}>
                {options ? options.map((dropdownItem) => {
                    return dropdownItem?.link ? (
                        <Dropdown.Item key={dropdownItem.text} target={dropdownItem.target} href={dropdownItem.link}>
                            {dropdownItem.text}
                        </Dropdown.Item>
                    ) : (
                        <Dropdown.Item key={dropdownItem.text} onClick={dropdownItem.method}>
                            {dropdownItem.text}
                        </Dropdown.Item>
                    );
                }): children}
            </Dropdown.Menu>}
        </Dropdown>
    );
}
